<!-- eslint-disable -->
<template>
  <v-footer class="site-footer pa-4">
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
          <!-- Links -->
          <div class="footer-links mb-3">
            <router-link to="/about" class="footer-link">{{ $t('footer.about') }}</router-link>
            <span class="mx-2">•</span>
            <router-link to="/faq" class="footer-link">{{ $t('footer.faq') }}</router-link>
            <span class="mx-2">•</span>
            <router-link to="/terms" class="footer-link">{{ $t('footer.terms') }}</router-link>
            <span class="mx-2">•</span>
            <router-link to="/privacy" class="footer-link">{{ $t('footer.privacy') }}</router-link>
          </div>
          
          <!-- Copyright -->
          <div class="text-caption text-grey">
            © {{ currentYear }} Gørlev Station. All rights reserved.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script setup>
/* eslint-disable */
const currentYear = new Date().getFullYear()
</script>

<style scoped>
.site-footer {
  background: rgba(var(--v-theme-surface), 1);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: auto;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.footer-link {
  color: rgb(var(--v-theme-primary));
  text-decoration: none;
  font-size: 0.875rem;
}

.footer-link:hover {
  text-decoration: underline;
}
</style>